import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "dropdown-header",
  style: {"font-size":"0.75rem"}
}

interface PropsInterface {
  title: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'MenuHeader',
  props: {
    title: null
  },
  setup(__props: any) {

const props = __props as {
  title: string;
};



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", null, [
    _createElementVNode("h6", _hoisted_1, _toDisplayString(props.title), 1)
  ]))
}
}

})